import React from 'react'
import cx from 'classnames'
import url from 'libraries/front-end-core/core/url'
import { SEARCH } from 'constants/controllers'
import { MAX_SEARCH_RESULTS } from 'components/search/Pagination'

const Heading = (props) => {
  const getUrl = () => {
    const { pageNumber, query, searchPhrase, aol, flavour: _flavour, searchType } = props
    const flavour = searchType === 'qa' && _flavour
    const urlParams = { searchPhrase, pageNumber: pageNumber !== 'all' && 'all', searchType, aol, flavour }
    const urlQuery = { ...query, p: pageNumber !== 'all' ? 'all' : 1 }

    return url(SEARCH, urlParams, urlQuery)
  }
  const activeLinkHref = getUrl()

  return (
    <>
      <section className='f4 fw6 pb5 pt6'>
        {props.title}
      </section>
      <Pagination {...{ ...props, activeLinkHref }} />
    </>
  )
}

export default Heading

const Pagination = (props) => {
  const { pageNumber, resultCount, activeLinkHref } = props

  if (resultCount === 0) {
    return null
  }

  return (
    <div className='cadet-blue bg-white lh-title f6 pl6 pv3'>
      <ResultsShowing {...props} />
      <ShowAllLink {...{ pageNumber, activeLinkHref }} />
      <ShowTenLink {...{ pageNumber, activeLinkHref }} />
    </div>
  )
}

const ResultsShowing = ({ pageLimit, pageNumber, resultsOnPage, resultCount: _resultCount }) => {
  let lowerLimit = pageLimit * (pageNumber - 1) + 1
  lowerLimit = lowerLimit > 0 ? lowerLimit : 1
  const upperLimit = lowerLimit + resultsOnPage - 1
  const resultCount = Math.min(_resultCount, MAX_SEARCH_RESULTS)

  return (
    <span className='db-m mb3-m'>
      {pageNumber === 'all' ? `Showing ${resultCount} results` : `Showing ${lowerLimit}-${upperLimit} of ${resultCount}`}
    </span>
  )
}

const ShowAllLink = ({ pageNumber, activeLinkHref }) => {
  const href = pageNumber === 'all' ? null : activeLinkHref
  const className = cx('pl5 pl0-m', {
    underline: pageNumber === 'all',
    'no-underline': pageNumber !== 'all'
  })

  return (
    <a {...{ className, href }}>
      Show all
    </a>
  )
}

const ShowTenLink = ({ pageNumber, activeLinkHref }) => {
  return (
    <a
      className={cx('pl5',
        {
          underline: pageNumber !== 'all',
          'no-underline': pageNumber === 'all'
        }
      )}
      href={pageNumber !== 'all' ? null : activeLinkHref}
    >
      Show 10
    </a>
  )
}
